import React, {useContext, useEffect, useMemo, useState} from "react";
import {Operation, PageFor} from "../../../../../utils/Enum.types";
import {Button} from "../../../../../stories/Button/Button";
import {Title} from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import {Label} from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import {
  Autocomplete,
  Avatar,
  Box,
  FormControlLabel,
  TextField,
} from "@mui/material";
import {
  CustomModal,
  handleFormEvent,
  handleMUISelectEvent,
} from "../../../../../utils/UtilFunctions";
import AddImage from "../../../../../images/Add.svg";
import {AntSwitch} from "../../../../../styles/Switch";
import {AddModalStyles} from "../../../../../styles/CustomModalStyles";
import ItemGroup from "../itemgroup/Index";
import {TOOLTIP_COLORS} from "../../../../../styles/Variables";
import {useLazyQuery, useMutation} from "@apollo/client";
import {GetItemByNodeId, GetItems} from "./queries/queries";
import {nodeVar, OrderDirection} from "../../../../../utils/commonQueryTypes";
import {
  AddItemResult,
  AddItemVar,
  AtsStckItem,
  AtsStckItemOrderField,
  CreateAtsStckItemInput,
  ItemQueryType,
  UpdateItemResult,
  UpdateItemVar,
} from "./queries/types";
import {AddItem, UpdateItem} from "./queries/mutations";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import {Form, Formik, FormikProps} from "formik";
import {optionsType, stockItemInputs} from "../../../../../utils/formTypes";
import {itemValidation} from "../../../../../utils/validationSchema";
import {LabelProps} from "../../../../../utils/types";
import InputNumber from "../../../../common/Input/InputNumber";
import InputHoc from "../../../../common/Input/Index";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import ItemManufacturer from "../../../../../customComponents/ItemManufacturerSelect";
import UoMSelect from "../../../../../customComponents/UoMSelect";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import {AppContext} from "../../../../../context/context";
import MessageModal from "../../../../../customComponents/MessageModal";
import Category from "../category/Index";
import UnitofMeasurement from "../unitOfMeasurment/Index";
import Manufacturer from "../manufacturer/Index";
import LoadingModal from "../../../../pages/LoadingModal";
import {CustomTooltip} from "../../../../../styles/TooltipStyles";
import ItemConfiguration from "./configurations/ItemConfiguration";
import {GetSwConfigVariables} from "./configurations/queries/queries";
import {
  GetSwConfigVariablesResult,
  GetSwConfigVariablesVar,
  SwConfigQueryType,
} from "./configurations/queries/type";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import {Keys} from "../../../../../utils/Enum.keys";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
// import Camera from "../../../../../images/ItemIcons/camera.svg";
// import Signals from "../../../../../images/ItemIcons/signals.svg";
// import Walkie from "../../../../../images/ItemIcons/walkie talkie.svg";

interface Props {
  operation: Operation;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

enum StockService {
  SERVICE = "Service",
  STOCK = "Stock",
}

const configVariables = {
  isConsumable: "ITEM_CONSUMABLE",
  imageNeeded: "ITEM_IMAGE_NEEDED",
  trackInstallation: "ITEM_TRACK_INSTALLATION",
  trackInsurance: "ITEM_TRACK_INSURANCE",
  trackMaintenance: "ITEM_TRACK_MAINTENANCE",
  trackSerial: "ITEM_TRACK_SERIAL",
  trackWarranty: "ITEM_TRACK_WARRANTY",
  isPerishable: "ITEM_PERISHABLE",
  trackAmc: "ITEM_TRACK_AMC",
  trackBatch: "ITEM_TRACK_BATCH",
  trackExpiry: "ITEM_TRACK_EXPIRY",
  trackGeoLocation: "ITEM_TRACK_GEO_LOCATION",
};

interface FormFieldsType extends LabelProps {
  enable: boolean;
}
const Add = ({operation, setModalFlag}: Props) => {
  const {customer_id, company_id} = useUrlParams();
  const {ItemsForm} = useFormJson();
  const {state} = useContext(AppContext);
  const [itemgroup, setItemGroup] = useState(false);
  const [category, setCategory] = useState(false);
  const [unit, setUnit] = useState(false);
  const [configurations, setConfigurations] = useState(false);
  const [manufacturer, setManufacturer] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [browse, setBrowse] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const [value, setValue] = useState("");
  const {itemLabel} = useLabels();
  interface Item {
    id: number;
    name: string;
    type: string;
  }

  const [dynamicFieldData, setDynamicFieldData] = useState<Item[]>([]);

  const {user_details} = useLoggedInUserDetails();

  const [GetSwVariablesData, {data, loading}] = useLazyQuery<
    GetSwConfigVariablesResult,
    GetSwConfigVariablesVar
  >(GetSwConfigVariables);

  const initialValues: stockItemInputs = {
    cgst: "",
    code: "",
    desc: "",
    enableGst: false,
    hsnCode: "",
    igst: "",
    image_path: "",
    imageNeeded: false,
    isComponent: false,
    isConsumable: false,
    isModule: false,
    isPerishable: false,
    isStockOrService: "",
    sgst: "",
    stckCategoryID: 0,
    stckGroupID: 0,
    stckManufacturerID: 0,
    stckUomID: 0,
    trackAmc: false,
    trackBatch: false,
    trackBrand: false,
    trackModel: false,
    trackExpiry: false,
    trackGeoLocation: false,
    trackInstallation: false,
    trackInsurance: false,
    trackMaintenance: false,
    trackSerial: false,
    trackWarranty: false,
    trackCalibration: false,
    uom: "",
    additionalPropertyNeeded: false,
    noOfAdditionalProperties: 0,
    AdditionalPropertyDesc1: "",
    AdditionalPropertyDesc2: "",
    AdditionalPropertyDesc3: "",
    AdditionalPropertyDesc4: "",
    AdditionalPropertyDesc5: "",
    AdditionalPropertyDesc6: "",
    AdditionalPropertyDesc7: "",
    AdditionalPropertyDesc8: "",
    AdditionalPropertyDesc9: "",
    AdditionalPropertyDesc10: "",
    AdditionalPropertyDatatype1: "",
    AdditionalPropertyDatatype2: "",
    AdditionalPropertyDatatype3: "",
    AdditionalPropertyDatatype4: "",
    AdditionalPropertyDatatype5: "",
    AdditionalPropertyDatatype6: "",
    AdditionalPropertyDatatype7: "",
    AdditionalPropertyDatatype8: "",
    AdditionalPropertyDatatype9: "",
    AdditionalPropertyDatatype10: "",
    stckDetailsEntryIsMultiple: false,
    icon: "",
  };

  const fileNames = [
    "360 deg Camera",
    "ALcometer",
    "Body Camera",
    "camera",
    "Desktop",
    "Drones",
    "Horizontal Signal",
    "Led Board",
    "SpeedCam",
    "Swiping Machine",
    "Tab",
    "Vertical Signal",
    "walkie talkie",
    "Warning Poles",
    "signals",
  ];

  const icons: optionsType[] = useMemo(() => {
    return fileNames.map((file) => {
      return {
        label: require(`${process.env.React_App_Img_Icons}/${file}.svg`),
        value: file,
      };
    });
  }, []);

  const [formData, setFormData] = useState<stockItemInputs>(initialValues);

  const [GetItemById, {loading: GetItemByNodeIdLoading}] = useLazyQuery<
    {node: AtsStckItem},
    nodeVar
  >(GetItemByNodeId);

  const [AddItemDetails, {loading: AddItemLoading}] = useMutation<
    AddItemResult,
    AddItemVar
  >(AddItem, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateItemDetails] = useMutation<UpdateItemResult, UpdateItemVar>(
    UpdateItem,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );
  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files[0];
      setFile(image_as_files);
    }
  };

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<stockItemInputs>
  ) => {
    const {name, value} = e.target as HTMLInputElement;
    if (name === "igst") {
      setFormData(() => ({
        ...formData,
        [name]: value,
        ["sgst"]: (Number(value) / 2).toString(),
        ["cgst"]: (Number(value) / 2).toString(),
      }));
    } else {
      setFormData(() => ({
        ...formData,
        [name]: value,
      }));
    }

    meta.handleChange(e);
  };

  const handleChecked = (
    e: React.ChangeEvent<HTMLInputElement>,
    meta: FormikProps<stockItemInputs>
  ) => {
    const {name, checked} = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: checked,
    }));
    meta.handleChange(e);
  };

  const handleSubmit = async () => {
    try {
      if (customer_id) {
        if (operation === Operation.CREATE) {
          const empAdded = AddItemDetails({
            variables: {
              user_details,
              customer_id,
              input: {
                ...(formData as unknown as CreateAtsStckItemInput),
                igst: Number(formData.igst),
                cgst: Number(formData.cgst),
                sgst: Number(formData.sgst),
              },
            },
            refetchQueries: [
              {
                query: GetItems,
                variables: {
                  after: null,
                  customerID: customer_id ? customer_id : 0,
                  companyID: company_id ? company_id : 0,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemOrderField.DESC,
                  },

                  name: EMPTY_STRING,
                  hsnCode: EMPTY_STRING,
                  input: {
                    query_type: ItemQueryType.All,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    ldgrID: 0,
                    subsidiaryID: 0,
                  },
                },
              },
            ],
          });
          const {data} = await empAdded;

          if (data && data.AddItem) {
            setMessage({
              flag: true,
              message: `${itemLabel} added successfully`,
              operation: Operation.CREATE,
            });
          }
        } else {
          const customerUpdated = UpdateItemDetails({
            variables: {
              user_details,
              item_id: state.itmId,
              input: {
                ...(formData as unknown as CreateAtsStckItemInput),
                igst: Number(formData.igst),
                cgst: Number(formData.cgst),
                sgst: Number(formData.sgst),
              },
            },
            refetchQueries: [
              {
                query: GetItems,
                variables: {
                  after: null,
                  customerID: customer_id ? customer_id : 0,
                  companyID: company_id ? company_id : 0,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemOrderField.DESC,
                  },

                  name: EMPTY_STRING,
                  hsnCode: EMPTY_STRING,
                  input: {
                    query_type: ItemQueryType.All,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    ldgrID: 0,
                    subsidiaryID: 0,
                  },
                },
              },
            ],
          });
          const {data} = await customerUpdated;

          if (data && data.UpdateItem) {
            setMessage({
              flag: true,
              message: `${itemLabel} details updated successfully`,
              operation: Operation.CREATE,
            });
          }
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (state.itmId && operation === Operation.UPDATE) {
          GetItemById({
            variables: {
              id: state.itmId,
            },
          }).then(({data}) => {
            if (data && data.node) {
              setFormData({
                cgst: data.node.cgst.toString(),
                code: data.node.code,
                desc: data.node.desc,
                enableGst: data.node.enableGst,
                igst: data.node.igst.toString(),
                image_path: "",
                imageNeeded: false,
                isComponent: data.node.isComponent,
                isConsumable: data.node.isConsumable,
                isModule: data.node.isModule,
                isPerishable: data.node.isPerishable,
                isStockOrService: data.node.isStockOrService,
                sgst: data.node.sgst.toString(),
                stckCategoryID: data.node.stckCategoryID,
                stckGroupID: data.node.stckGroupID,
                stckManufacturerID: data.node.stckManufacturerID,
                stckUomID: data.node.stckUomID,
                trackAmc: data.node.trackAmc,
                trackBatch: data.node.trackBatch,
                trackExpiry: data.node.trackExpiry,
                trackGeoLocation: data.node.trackGeoLocation,
                trackInstallation: data.node.trackInstallation,
                trackInsurance: data.node.trackInsurance,
                trackMaintenance: data.node.trackMaintenance,
                trackSerial: data.node.trackSerial,
                trackWarranty: data.node.trackWarranty,
                trackCalibration: data.node.trackCalibration,
                uom: data.node.uom,
                additionalPropertyNeeded: data.node.additionalPropertyNeeded,
                noOfAdditionalProperties: data.node.noOfAdditionalProperties,
                AdditionalPropertyDesc1: data.node.AdditionalPropertyDesc1,
                AdditionalPropertyDesc2: data.node.AdditionalPropertyDesc2,
                AdditionalPropertyDesc3: data.node.AdditionalPropertyDesc3,
                AdditionalPropertyDesc4: data.node.AdditionalPropertyDesc4,
                AdditionalPropertyDesc5: data.node.AdditionalPropertyDesc5,
                AdditionalPropertyDesc6: data.node.AdditionalPropertyDesc6,
                AdditionalPropertyDesc7: data.node.AdditionalPropertyDesc7,
                AdditionalPropertyDesc8: data.node.AdditionalPropertyDesc8,
                AdditionalPropertyDesc9: data.node.AdditionalPropertyDesc9,
                AdditionalPropertyDesc10: data.node.AdditionalPropertyDesc10,
                AdditionalPropertyDatatype1:
                  data.node.AdditionalPropertyDatatype1,
                AdditionalPropertyDatatype2:
                  data.node.AdditionalPropertyDatatype2,
                AdditionalPropertyDatatype3:
                  data.node.AdditionalPropertyDatatype3,
                AdditionalPropertyDatatype4:
                  data.node.AdditionalPropertyDatatype4,
                AdditionalPropertyDatatype5:
                  data.node.AdditionalPropertyDatatype5,
                AdditionalPropertyDatatype6:
                  data.node.AdditionalPropertyDatatype6,
                AdditionalPropertyDatatype7:
                  data.node.AdditionalPropertyDatatype7,
                AdditionalPropertyDatatype8:
                  data.node.AdditionalPropertyDatatype8,
                AdditionalPropertyDatatype9:
                  data.node.AdditionalPropertyDatatype9,
                AdditionalPropertyDatatype10:
                  data.node.AdditionalPropertyDatatype10,
                stckDetailsEntryIsMultiple: false,
                hsnCode: data.node.hsnCode,
                trackBrand: data.node.trackBrand,
                trackModel: data.node.trackModel,
                icon: data.node.icon,
              });

              const transformFormDataToData = () => {
                const result: Item[] = [];

                // Group Desc and Datatype pairs
                for (let i = 1; i <= 10; i++) {
                  const descKey =
                    `AdditionalPropertyDesc${i}` as keyof AtsStckItem;
                  const datatypeKey =
                    `AdditionalPropertyDatatype${i}` as keyof AtsStckItem;

                  if (data.node[descKey] && data.node[datatypeKey]) {
                    result.push({
                      id: i,
                      name: data.node[descKey] as string,
                      type: data.node[datatypeKey] as string,
                    });
                  }
                }

                setDynamicFieldData(result);
              };
              transformFormDataToData();
            }
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [state.itmId, GetItemById, operation]);

  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "desc"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  const formModified = useMemo(() => {
    return ItemsForm.configurations.map((field: LabelProps) => {
      const configKey = (configVariables as Record<string, string>)[
        field.inputName
      ];

      const foundConfig = data
        ? data.GetSwConfigVariables.find(
            (config) => config.configKey === configKey
          )
        : null;

      if (foundConfig) {
        return {
          ...field,
          enable: foundConfig.booleanValue,
        };
      } else {
        return {...field, enable: false};
      }
    });
  }, [data, ItemsForm.configurations, configVariables]);

  useEffect(() => {
    if (customer_id) {
      GetSwVariablesData({
        variables: {
          customerID: customer_id,
          input: {
            queryType: SwConfigQueryType.ALL_CONFIGS,
          },
        },
      });
    }
  }, [customer_id, GetSwVariablesData]);

  return (
    <>
      <Formik
        initialValues={formData}
        validationSchema={itemValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="items__add">
              <div className="items__add--title">
                <Title>{`${
                  operation === Operation.CREATE
                    ? "Add"
                    : operation === Operation.UPDATE
                    ? "Update"
                    : "View"
                } Stock ${itemLabel}`}</Title>
                <img src={Close} alt="" onClick={() => setModalFlag(false)} />
              </div>

              <div className="items__add--form">
                <div className="items__add--form--left">
                  <div className="items__add--form--details">
                    <h4>{itemLabel} Descriptions</h4>
                  </div>
                  {ItemsForm.descriptions.map(
                    (field: LabelProps, key: React.Key) => {
                      if (field.dataType === "group") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <div className="items__add--form--details--flex">
                              <ItemGroupSelect
                                onChange={(newValue) => {
                                  if (newValue) {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: newValue.value,
                                    });
                                  } else {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: 0,
                                    });
                                  }
                                }}
                                value={formData[field.inputName] as number}
                                onKeyDown={handleMUISelectEvent}
                                label=""
                              />

                              <CustomTooltip
                                title={`Add ${itemLabel} Group`}
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: TOOLTIP_COLORS.VARIABLE,
                                      "& .MuiTooltip-arrow": {
                                        color: TOOLTIP_COLORS.VARIABLE,
                                      },
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={AddImage}
                                  alt=""
                                  className="data-fetch-icon"
                                  onClick={() => setItemGroup(!itemgroup)}
                                />
                              </CustomTooltip>
                            </div>
                          </div>
                        );
                      } else if (field.dataType === "category") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <div className="items__add--form--details--flex">
                              <ItemCategorySelect
                                onChange={(newValue) => {
                                  if (newValue) {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: newValue.value,
                                    });
                                  } else {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: 0,
                                    });
                                  }
                                }}
                                value={formData[field.inputName] as number}
                                onKeyDown={handleMUISelectEvent}
                                label=""
                              />
                              <CustomTooltip
                                title={`Add ${itemLabel} Group`}
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: TOOLTIP_COLORS.VARIABLE,
                                      "& .MuiTooltip-arrow": {
                                        color: TOOLTIP_COLORS.VARIABLE,
                                      },
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={AddImage}
                                  alt=""
                                  className="data-fetch-icon"
                                  onClick={() => setCategory(!category)}
                                />
                              </CustomTooltip>
                            </div>
                          </div>
                        );
                      } else if (field.dataType === "manufacturer") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <div className="items__add--form--details--flex">
                              <ItemManufacturer
                                label=""
                                onChange={(newValue) => {
                                  if (newValue) {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: newValue.value,
                                    });
                                  } else {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: 0,
                                    });
                                  }
                                }}
                                value={formData[field.inputName] as number}
                                onKeyDown={handleMUISelectEvent}
                              />
                              <CustomTooltip
                                title="Add Manufacturer"
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: TOOLTIP_COLORS.VARIABLE,
                                      "& .MuiTooltip-arrow": {
                                        color: TOOLTIP_COLORS.VARIABLE,
                                      },
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={AddImage}
                                  alt=""
                                  className="data-fetch-icon"
                                  onClick={() => setManufacturer(!manufacturer)}
                                />
                              </CustomTooltip>
                            </div>
                          </div>
                        );
                      } else if (field.dataType === "uom") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <div className="items__add--form--details--flex">
                              <UoMSelect
                                onChange={(newValue) => {
                                  if (newValue) {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: newValue.value,
                                    });
                                  } else {
                                    setFormData({
                                      ...formData,
                                      [field.inputName]: 0,
                                    });
                                  }
                                }}
                                value={formData[field.inputName] as number}
                                onKeyDown={handleMUISelectEvent}
                                label=""
                              />
                              <CustomTooltip
                                title="Add Unit of Measurement"
                                arrow
                                placement="top"
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      bgcolor: TOOLTIP_COLORS.VARIABLE,
                                      "& .MuiTooltip-arrow": {
                                        color: TOOLTIP_COLORS.VARIABLE,
                                      },
                                    },
                                  },
                                }}
                              >
                                <img
                                  src={AddImage}
                                  alt=""
                                  className="data-fetch-icon"
                                  onClick={() => setUnit(!unit)}
                                />
                              </CustomTooltip>
                            </div>
                          </div>
                        );
                      } else if (field.dataType === "boolean") {
                        return (
                          <>
                            <FormControlLabel
                              label="Enable GST"
                              labelPlacement="start"
                              name={field.inputName}
                              control={
                                <AntSwitch
                                  checked={formData[field.inputName] as boolean}
                                  onChange={(e) => {
                                    handleChecked(e, meta);
                                  }}
                                  onKeyDown={handleFormEvent}
                                />
                              }
                              className="items__add--form-labels"
                            />
                            {formData.enableGst ? (
                              <>
                                {field.formFields
                                  ? field.formFields.map(
                                      (
                                        sub_field: LabelProps,
                                        sub_key: React.Key
                                      ) => {
                                        return (
                                          <div
                                            className="label-grid"
                                            key={sub_key}
                                          >
                                            <Label>{sub_field.labelName}</Label>
                                            <InputNumber
                                              value={
                                                formData[sub_field.inputName]
                                              }
                                              onChange={(
                                                e: React.ChangeEvent<HTMLInputElement>
                                              ) => {
                                                handleValueChange(e, meta);
                                              }}
                                              name={sub_field.inputName}
                                              maxLength={sub_field.maxLength}
                                              onKeyDown={handleFormEvent}
                                            />
                                          </div>
                                        );
                                      }
                                    )
                                  : null}
                              </>
                            ) : null}
                          </>
                        );
                      } else {
                        return (
                          <InputHoc
                            LabelName={field.labelName}
                            values={formData[field.inputName]}
                            name={field.inputName}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleValueChange(e, meta)}
                            autoFocus={field.autoFocus}
                            required={field.required}
                            onKeyDown={handleFormEvent}
                          />
                        );
                      }
                    }
                  )}
                </div>
                <div className="items__add--form--right">
                  <div className="items__add--form--details">
                    <h4>{itemLabel} Configurations</h4>
                  </div>
                  {formModified.map((field: FormFieldsType, key: React.Key) => {
                    if (!field.enable) {
                      if (field.dataType === "boolean") {
                        return (
                          <FormControlLabel
                            label={field.labelName}
                            labelPlacement="start"
                            name={field.inputName}
                            control={
                              <AntSwitch
                                checked={formData[field.inputName] as boolean}
                                onChange={(e) => {
                                  handleChecked(e, meta);
                                }}
                                onKeyDown={handleFormEvent}
                              />
                            }
                            className="items__add--form--details--form-labels"
                          />
                        );
                      } else if (field.dataType === "icon") {
                        return (
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <FormAutocomplete
                              className={formClasses.inputRoot}
                              options={icons}
                              //   onKeyDown={(e) => {
                              //     if (e.key === Keys.ENTER) {
                              //       e.preventDefault();
                              //       handleMUISelectEvent(e);
                              //     }
                              //   }}

                              renderOption={(props, option) => {
                                return (
                                  <Box
                                    component="li"
                                    {...props}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <Avatar
                                      src={(option as optionsType).label}
                                      sx={{marginRight: 2}}
                                    />
                                  </Box>
                                );
                              }}
                              openOnFocus
                              forcePopupIcon
                              onChange={(e, newValue) => {
                                setFormData({
                                  ...formData,
                                  icon: (newValue as optionsType).value,
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  className={formClasses.formControlRoot}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: value ? (
                                      <img
                                        src={value}
                                        // alt={value}
                                        // sx={{
                                        //   width: 40,
                                        //   height: 40,
                                        //   marginRight: 1,
                                        // }}
                                      />
                                    ) : null,
                                  }}
                                />
                              )}
                            />
                          </div>
                        );
                      } else if (field.dataType === "stock_service") {
                        return (
                          <div >
                            <Label>{field.labelName}</Label>
                            <FormAutocomplete
                              className={formClasses.inputRoot}
                              options={["Stocks", "Service"]}
                              onKeyDown={(e) => {
                                if (e.key === Keys.ENTER) {
                                  e.preventDefault();
                                  handleMUISelectEvent(e);
                                }
                              }}
                              onChange={(e, newValue) => {
                                setFormData({
                                  ...formData,
                                  [field.inputName]: newValue as string,
                                });
                              }}
                              value={formData[field.inputName]}
                              openOnFocus
                              forcePopupIcon
                              freeSolo
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  className={formClasses.formControlRoot}
                                />
                              )}
                            />
                          </div>
                        );
                      } else {
                        return (
                          <InputHoc
                            LabelName={field.labelName}
                            values={formData[field.inputName]}
                            name={field.inputName}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleValueChange(e, meta)}
                            autoFocus={field.autoFocus}
                            required={field.required}
                            onKeyDown={handleFormEvent}
                          />
                        );
                      }
                    }
                  })}

                  <div className="items__add--predefined">
                    <ul>
                      {dynamicFieldData.map((label) => {
                        return (
                          <li>
                            <div className="label-grid">
                              <Label>{label.name}</Label>
                              <Input
                                type={label.type}
                                placeholder={label.type}
                              />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
              <CustomModal
                isOpen={itemgroup}
                onRequestClose={() => setItemGroup(!itemgroup)}
                style={AddModalStyles}
                contentComponent={
                  <ItemGroup type={PageFor.MODAL} setModal={setItemGroup} />
                }
              />
              <CustomModal
                isOpen={category}
                onRequestClose={() => setCategory(!category)}
                style={AddModalStyles}
                contentComponent={
                  <Category type={PageFor.MODAL} setModal={setCategory} />
                }
              />
              <CustomModal
                isOpen={manufacturer}
                onRequestClose={() => setManufacturer(!manufacturer)}
                style={AddModalStyles}
                contentComponent={
                  <Manufacturer
                    type={PageFor.MODAL}
                    setModal={setManufacturer}
                  />
                }
              />
              <CustomModal
                isOpen={unit}
                onRequestClose={() => setUnit(!unit)}
                style={AddModalStyles}
                contentComponent={
                  <UnitofMeasurement type={PageFor.MODAL} setModal={setUnit} />
                }
              />
              <div className="row g-0">
                <div className="col">
                  <Button mode="save" type="submit" />
                  <Button mode="clear" type="button" onClick={handleClear} />
                  <Button
                    mode="cancel"
                    type="button"
                    onClick={() => setModalFlag(false)}
                  />
                </div>
                <div className="col-3 flex-end">
                  <Button
                    type="button"
                    mode="configure"
                    onClick={() => setConfigurations(true)}
                  />
                </div>
              </div>

              <MessageModal
                handleClose={handleClose}
                modalFlag={message.flag}
                operation={message.operation}
                value={message.message}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={GetItemByNodeIdLoading || AddItemLoading} />
      <CustomModal
        isOpen={configurations}
        onRequestClose={() => setConfigurations(!configurations)}
        style={AddModalStyles}
        contentComponent={
          <ItemConfiguration
            listdata={{
              formData,
              setFormData,
              dynamicFieldData,
              setDynamicFieldData,
            }}
            setModalFlag={setConfigurations}
          />
        }
      />
    </>
  );
};

export default Add;
